<template>
    <div class="image-wrapper overflow-hidden relative rounded" :style="{ aspectRatio: aspectRatio }">
        <Transition name="fade" mode="out-in">
            <img :src="imageSrc" :key="imageSrc" alt="Image" class="w-full h-full object-cover">
        </Transition>
    </div>
</template>

<script setup>
const props = defineProps({
    imageSrc: {
        type: String,
        required: true
    },
    aspectRatio: {
        type: String,
        default: '9/16'
    }
})
</script>